import styles from './index.module.scss';
import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/app/utils/useLang';
import EcoImg from 'eco-design/base/eco-img';
import EcoSpace from 'eco-design/base/eco-space';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import { useRef } from 'react';
import { Navigation, Scrollbar } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useGlobal } from '@/utils/useGlobal';

const Stories: React.FC = () => {
    const { locale } = getLocal();
    const { gtm } = useGlobal();
    const { t } = useLang('Stories');
    const swiperRef = useRef<any>(null);
    const list: { [key: string]: any } = [
        {
            title: t('list_title_1'),
            desc: t('list_desc_1'),
            bg: {
                us: 'https://websiteoss.ecoflow.com/upload/image/1749612704045/bg1.jpg',
                ca: 'https://websiteoss.ecoflow.com/upload/image/1754275500018/image%20(19).jpg',
            },
            link: {
                us: 'https://www.facebook.com/groups/615288075629942/user/706030732/?__cft__[0]=AZVQSBq8cjIjnShELL7-auCYkyISSPdpiS94uMbAUJ1R67YkOvuS_qnglF3rbxrnpTa45PUGWIlzHaC3pnlif0Vhyfqj33A80H4qgrKUGRCuxkQPmdeOjfoAP_s_mxUktZxI2UENYB3m4NkrqUPlL-ad&__tn__=-UC%2CP-R',
                ca: 'https://www.facebook.com/groups/615288075629942/user/706030732/?__cft__[0]=AZVQSBq8cjIjnShELL7-auCYkyISSPdpiS94uMbAUJ1R67YkOvuS_qnglF3rbxrnpTa45PUGWIlzHaC3pnlif0Vhyfqj33A80H4qgrKUGRCuxkQPmdeOjfoAP_s_mxUktZxI2UENYB3m4NkrqUPlL-ad&__tn__=-UC%2CP-R',
            },
        },
        {
            title: t('list_title_2'),
            desc: t('list_desc_2'),
            bg: {
                us: 'https://websiteoss.ecoflow.com/upload/image/1749612704481/bg2.jpg',
                ca: 'https://websiteoss.ecoflow.com/upload/image/1754275492038/image%20(3)%20(1).jpg',
            },
            link: {
                us: 'https://www.facebook.com/groups/1149081025558751/user/100000177080325/?__cft__[0]=AZXNHJ0QlGahOxDKdiWtX4hHarYC-hKmVu-q_2lMfrf_o2jJDBSa7QVqe0liNLnZdtfKOhWxeecVkJ04WZTAx_BNH03rUo2BcNzu8zcYIKJhasM88_4diiaaer_vBk3Q1cUK6Ie3Ns9iRG5Ou2Ggha5jMYLKBiBgvE9R4Wu8S9BB5g&__tn__=-UC%2CP-R',
                ca: 'https://www.facebook.com/groups/1149081025558751/user/1662435376',
            },
        },
        {
            title: t('list_title_3'),
            desc: t('list_desc_3'),
            bg: {
                us: 'https://websiteoss.ecoflow.com/upload/image/1749612703605/bg3.jpg',
                ca: 'https://websiteoss.ecoflow.com/upload/image/1754276877826/image%20(4)%20(1).jpg',
            },
            link: {
                us: 'https://www.facebook.com/groups/1149081025558751/user/100000802181294/?__cft__[0]=AZWeehuGmRVcgfbR91rJPJFDmN_g-cafX949eRtQWh1Rn01nEHeE6tpHE1NxjDzC1kA4Ewz7N8cpAN9EqsUfBTxy99eHi8B8rhiO1YZS-7NLNnV6jg0z2B1-Pkjuw8uqICSjuN1dDjz3pPnDaVoZbpHEZ7aZB_Gs3P-kZmBQQ2TW_w&__tn__=-UC%2CP-R',
                ca: 'https://www.facebook.com/groups/615288075629942/user/569981515/?__cft__[0]=AZXQ0cCJYm-mo7i1EHPKTynnzZF3P-bW3JAJR6ru6EyLfcWrDRLue-mjuK__SNs28NGTVomC5ENIKpqXPqMsS2eJRmwcxNKGKEEjBDLZo5JTIWRk4D0ufNk7YEsqFfJ7T-R0Mf7ybWxAdB2XkAoOnaTY&__tn__=-UC%2CP-R',
            },
        },
        {
            title: t('list_title_4'),
            desc: t('list_desc_4'),
            bg: {
                us: 'https://websiteoss.ecoflow.com/upload/image/1749612703838/bg4.jpg',
                ca: 'https://websiteoss.ecoflow.com/upload/image/1754275491758/image%20(5)%20(1).jpg',
            },
            link: {
                us: 'https://www.facebook.com/groups/1149081025558751/user/517532952/?__cft__[0]=AZWwqdMGiL3MIFtaIYUnWOcb5cdwuqokd0voaQvaP70FmPeZmHxCcdYgHKh6UeIuDIn7WgPmlFnBMfry6vC-rxugFanNC8YqIweaobHS8hng3mTmUs3bSaLuurAk9LVZx_p5PCLX99J9Bz-WdXKbn8FO&__tn__=-UC%2CP-R',
                ca: 'https://www.facebook.com/groups/1149081025558751/user/517532952/?__cft__[0]=AZWwqdMGiL3MIFtaIYUnWOcb5cdwuqokd0voaQvaP70FmPeZmHxCcdYgHKh6UeIuDIn7WgPmlFnBMfry6vC-rxugFanNC8YqIweaobHS8hng3mTmUs3bSaLuurAk9LVZx_p5PCLX99J9Bz-WdXKbn8FO&__tn__=-UC%2CP-R',
            },
        },
        {
            title: t('list_title_5'),
            desc: t('list_desc_5'),
            bg: {
                us: 'https://websiteoss.ecoflow.com/upload/image/1749612704715/bg5.jpg',
                ca: 'https://websiteoss.ecoflow.com/upload/image/1754275491866/image%20(6)%20(1).jpg',
            },
            link: {
                us: 'https://www.facebook.com/groups/615288075629942/user/1710794370/?__cft__[0]=AZVuj_zKpRGEeJrdNoCr4RDxACpx-AnmPYrxHH_xWG_5mPBZchdHJfwvC5tkT4_xd_OGjeXRhMtsbCPE-8-B-8e1z2jWQjMFThQI_6MExowaREfQQjmnn31d9Unx0mhTfIfE62SgkI4Wyh6bVRbgN2Oj&__tn__=-UC%2CP-R',
                ca: 'https://www.facebook.com/groups/1149081025558751/user/100052483878767/?__cft__[0]=AZXgvbgfwHwEj6uZVIr2bQ37vsGJwR_g8ti2UtUs4cA-7xc9IkiyQE-_WQ0z88QU1Ud8otxGBqMxVwQSIuLeP2QcHQErWx8Qf10Jw-OXaU-Ulyl06_WjlqTM1yacRaEnIyM6spELhA7nQ_hbUT3_BKjVmKjFNgCbdMWUMe7ymNlxIQ&__tn__=-UC%2CP-R',
            },
        },
        {
            title: t('list_title_6'),
            desc: t('list_desc_6'),
            bg: {
                us: 'https://websiteoss.ecoflow.com/upload/image/1749612704275/bg6.jpg',
                ca: 'https://websiteoss.ecoflow.com/upload/image/1754275491886/Frame%206.jpg',
            },
            link: {
                us: 'https://www.facebook.com/groups/615288075629942/user/569981515/?__cft__[0]=AZXQ0cCJYm-mo7i1EHPKTynnzZF3P-bW3JAJR6ru6EyLfcWrDRLue-mjuK__SNs28NGTVomC5ENIKpqXPqMsS2eJRmwcxNKGKEEjBDLZo5JTIWRk4D0ufNk7YEsqFfJ7T-R0Mf7ybWxAdB2XkAoOnaTY&__tn__=-UC%2CP-R',
                ca: 'https://www.facebook.com/groups/1149081025558751/user/1230964689/',
            },
        },
        {
            title: t('list_title_7'),
            desc: t('list_desc_7'),
            bg: {
                us: 'https://websiteoss.ecoflow.com/upload/image/1749612703439/bg7.jpg',
                ca: 'https://websiteoss.ecoflow.com/upload/image/1754275491866/image%20(8)%20(1).jpg',
            },
            link: {
                us: 'https://www.facebook.com/groups/615288075629942/user/686386608/?__cft__[0]=AZWC9nwn6omJvdfPSioZjzq7djlbwDOxzCpozIw7FZLmgIwjylF58SrETLa6Gvw-dd6MzsMPAWWCqRvZbrqZwcFzjn0xUYLAG0FElb7zUeEikwM5ZuFri3sAT5i4Wh5a4EXnl2lmVU9MXVCVuo4dafFr&__tn__=-UC%2CP-R',
                ca: 'https://www.facebook.com/groups/615288075629942/user/686386608/?__cft__[0]=AZWC9nwn6omJvdfPSioZjzq7djlbwDOxzCpozIw7FZLmgIwjylF58SrETLa6Gvw-dd6MzsMPAWWCqRvZbrqZwcFzjn0xUYLAG0FElb7zUeEikwM5ZuFri3sAT5i4Wh5a4EXnl2lmVU9MXVCVuo4dafFr&__tn__=-UC%2CP-R',
            },
        },
    ];

    const handlePrev = () => {
        swiperRef.current?.slidePrev();
    };

    const handleNext = () => {
        swiperRef.current?.slideNext();
    };
    return (
        <div className={`${styles.Stories} GtmModuleData-section`} data-section-id={'powerPreparedness-Stories'} data-section-title={t('title')}>
            <div className="page-space"></div>
            <EcoSectionCommon
                title={t('title')}
                desc={t.rich('desc', {
                    link: (text: string) => <a href="https://bit.ly/4fWZA7C">{text}</a>,
                })}
            />
            <div className="list page-layout">
                <Swiper
                    onSwiper={(swiper) => {
                        swiperRef.current = swiper;
                    }}
                    slidesPerView={'auto'}
                    spaceBetween={24}
                    modules={[Navigation, Scrollbar]}
                    scrollbar={{
                        hide: false,
                        draggable: true,
                        dragSize: 25,
                        snapOnRelease: true,
                    }}
                    navigation={{
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    }}
                    initialSlide={0}
                    onSlideChange={(swiper) => {
                        if (swiper.previousIndex < swiper.activeIndex) {
                            gtm.push({
                                event: 'uaEvent',
                                event_name: 'product_detail_page',
                                list_name: 'What Our EcoFlow Users Think',
                                button_name: 'Right switch',
                            });
                        } else {
                            gtm.push({
                                event: 'uaEvent',
                                event_name: 'product_detail_page',
                                list_name: 'What Our EcoFlow Users Think',
                                button_name: 'Left switch',
                            });
                        }
                    }}
                >
                    {list.map((item, index) => (
                        <SwiperSlide key={index} className="list-item">
                            <EcoImg pc={item.bg[locale]} h5={item.bg[locale]} />
                            <div className="wrapper">
                                <div className="list-item-title" onClick={() => window.open(item.link[locale], '_blank')}>
                                    {item.title}
                                </div>
                                <div className="list-item-desc">{item.desc}</div>
                            </div>
                        </SwiperSlide>
                    ))}
                    <div className="swiper-button-prev" onClick={handlePrev} />
                    <div className="swiper-button-next" onClick={handleNext} />
                </Swiper>
            </div>
            <div className="page-space"></div>
        </div>
    );
};

export default Stories;
